(function () {
	'use strict';

    angular.module("imApp").factory("actStatusesService", ['$ihttp', function ($ihttp) {
        let service = {
            listActStatuses: function (parms) {
                return $ihttp.post({
                    method: 1331,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
